/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import Select from "../../../component/select";
import { withTranslation } from "react-i18next";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";

const UpdateDialog = (props) => {
  const [plan, setPlan] = useState("");

  return (
    <Dialog
      disableScrollLock={true}
      open={props.isOpen}
      fullWidth={true}
      maxWidth={"sm"}
      PaperComponent={DraggableDialogPaper}
    >
      {/* <DialogTitle id="draggableDialogPaper" style={{ cursor: 'move' }}>{props.t('CHANGE_SUBSCRIPTION_PLAN')}</DialogTitle>
            <DialogContent dividers>
                <Select
                    options={props.solutionPlans.filter(item=>(item.solutionPlanId!==props.selectedPlan && item.firstLevelFeatureId === props.firstLevelFeatureId))}
                    default={props.t('SELECT_SOLUTION_PLAN_TO_UPDATE')}
                    selected={plan}
                    value={(item)=>item.packageProductId}
                    optionLabel={(item)=>item.solutionPlanName}
                    onChange={(e)=>{setPlan(e.target.value)}}
                />
            </DialogContent> */}

      <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
        {props.t("CHANGE_SUBSCRIPTION")}
      </DialogTitle>
      <DialogContent dividers>
        <Select
          options={props.data.variants}
          default={props.t("SELECT_VARIANT")}
          selected={plan}
          value={(item) => item.productId}
          optionLabel={(item) => item.name}
          onChange={(e) => {
            setPlan(e.target.value);
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            props.close(false);
          }}
        >
          {props.t("CLOSE")}
        </Button>
        <Button
          onClick={() => {
            props.close(true, plan);
          }}
        >
          {props.t("SUBMIT")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(UpdateDialog);
